<template>
  <a-table
    :data-source="data"
    :loading="loading"
    :pagination="false"
    row-key="name"
    :columns="columns"
    :expandedRowRender="renderSubtopics"
  >
    <template slot="status" slot-scope="status">
      <a-tag :color="getStatusColor(status)" :style="getStatusStyle(status)">
        {{ status || 'Not Started' }}
      </a-tag>
    </template>

    <template slot="last_updated_by" slot-scope="text, record">
      <span>
        {{ text || 'N/A' }}
        <a-tag v-if="record.is_substitute" color="blue" style="margin-left: 8px;" size="small">Substitute</a-tag>
      </span>
    </template>
    <template slot="period" slot-scope="period">
      <span>{{ formatPeriod(period) }}</span>
    </template>

    <template slot="actions" slot-scope="text, record">
      <a-button type="info" size="small" @click="$emit('viewLogs', record, 'topic')">
        View Detail/Logs
      </a-button>
    </template>
  </a-table>
</template>

<script>
export default {
  name: 'SectionProgressTable',
  props: {
    data: Array,
    loading: Boolean,
  },
  data() {
    return {
      columns: [
        {
          title: 'Topic',
          dataIndex: 'name',
          key: 'name',
          width: 200,
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
          align: 'center',
        },
        {
          title: 'Last Updated By',
          dataIndex: 'last_updated_by',
          key: 'last_updated_by',
          scopedSlots: { customRender: 'last_updated_by' },
          width: 150,
        },
        {
          title: 'Period',
          dataIndex: 'period',
          key: 'period',
          scopedSlots: { customRender: 'period' },
          width: 100,
        },
        {
          title: 'Date',
          dataIndex: 'last_updated_on',
          key: 'last_updated_on',
          width: 120,
        },
        {
          title: 'Remarks',
          dataIndex: 'remarks',
          key: 'remarks',
          width: 200,
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: { customRender: 'actions' },
          width: 150,
          align: 'right',
        },
      ],
    }
  },
  methods: {
    renderSubtopics(record) {
      const subtopics = record.sub_topics || []
      if (!subtopics.length) return null
      return (
        <a-table
          dataSource={record.sub_topics}
          rowKey="name"
          size='medium'
          pagination={false}
          columns={[
            { title: 'Sub-topic', dataIndex: 'name', key: 'name', width: 300 },
            {
              title: 'Status',
              dataIndex: 'status',
              key: 'status',
              width: 120,
              align: 'center',
              customRender: (text) => (
                <a-tag color={this.getStatusColor(text)} style={this.getStatusStyle(text)}>
                  {text || 'Not Started'}
                </a-tag>
              ),
            },
            {
              title: 'Last Updated By',
              dataIndex: 'last_updated_by',
              key: 'last_updated_by',
              width: 180,
              customRender: (text, record) => (
                <span>
                  {text || 'N/A'}
                  {record.is_substitute ? <a-tag color="blue" style="marginLeft: '8px'">Substitute</a-tag> : null}
                </span>
              ),
            },
            {
              title: 'Period',
              dataIndex: 'period',
              key: 'period',
              width: 100,
              customRender: (text) => <span>{this.formatPeriod(text)}</span>,
            },
            { title: 'Date', dataIndex: 'last_updated_on', key: 'last_updated_on', width: 120 },
            { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' },
            {
              title: 'Actions',
              key: 'actions',
              width: 150,
              align: 'right',
              customRender: (text, row) => (
                <a-button type="info" size="small" onClick={() => this.$emit('viewLogs', row, 'sub-topic')}>
                  View Detail/Logs
                </a-button>
              ),
            },
          ]}
        />
      )
    },
    getStatusColor(status) {
      const s = (status || '').toLowerCase()
      if (s === 'completed') return 'green'
      if (s === 'in progress') return 'blue'
      if (s === 'started') return 'orange'
      return '#595959'
    },
    getStatusStyle(status) {
      const color = this.getStatusColor(status)
      if (color === '#595959') {
        return { color: '#ffffff', backgroundColor: '#595959', borderColor: '#595959' }
      }
      return {}
    },
    formatPeriod(period) {
      if (!period) return '-'
      const s = ['th', 'st', 'nd', 'rd']
      const v = period % 100
      return period + (s[(v - 20) % 10] || s[v] || s[0]) + ' Period'
    },
  },
}
</script>
